<div class="px-px-24 py-px-16">
  <div class="d-flex justify-content-between align-items-center flex-wrap gap-3">
    <div class="me-4 inner-add-on left-add-on my-3">
      <input type="search" class="form-control w-px-335"
             (input)="searchUser($event)"
             placeholder="Rechercher un collaborateur"
             autocomplete="off"/>
      <svg-icon class="inner-icon left" svgClass="placeholder-icon" src="/assets/icons/search-grey.svg"></svg-icon>
    </div>

    @if (permissions.has(AgencyPermission.USER_INVITE)) {
      <app-button text="Inviter un collaborateur" srcIcon="assets/icons/plus.svg"
                  (handleClick)="openInviteDialog()"></app-button>
    }
  </div>

  <div class="fs-13 text-neutral-dark-grey mb-px-12">
    Chaque collaborateur reçoit un e-mail d'invitation pour choisir son mot de passe.
    Ses droits dépendent de son rôle, ajustables compte par compte ; le dirigeant principal reste administrateur et ne peut pas être supprimé.
    Les comptes des professionnels de santé en attente se valident depuis « Comptes professionnels ».
  </div>

  @if (loading) {
    <app-loader></app-loader>
  } @else if (isMobile) {
    <div class="user-cards">
      @for (u of personsListFiltered; track u.id) {
        <div class="user-card">
          <div class="user-card-head">
            <div class="user-card-name">{{ u.firstName }} <span class="text-uppercase">{{ u.lastName }}</span></div>
            <app-user-status-cell [data]="u"></app-user-status-cell>
          </div>
          <div class="user-card-mail">{{ u.mail }}</div>
          <div class="user-card-meta">
            <app-user-role-cell [data]="u"></app-user-role-cell>
            @if (u.fonction) {
              <span class="user-card-fonction">{{ u.fonction }}</span>
            }
          </div>
          <div class="user-card-foot">
            <span class="user-card-login">Dernière connexion : {{ u.lastLogin }}</span>
            <app-user-action [data]="u"></app-user-action>
          </div>
        </div>
      } @empty {
        <div class="user-cards-empty">Aucun collaborateur trouvé.</div>
      }
    </div>
  } @else {
    <app-data-table
      [dataSource]="personsListFiltered"
      [columns]="columns"
      [totalItems]="totalItems"
      [pageSize]="100"
      (nextPage)="pagination($event)"
      [hasRowAction]="true"
      (rowActionClick)="handleRowClick($event)"
    ></app-data-table>
  }
</div>
